// Prettify a chain slug for display: "trgovina-krk" -> "Trgovina Krk".
export function prettyChain(slug) {
  return String(slug)
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (ch) => ch.toUpperCase())
}
